module.exports = __webpack_public_path__ + "assets/img/3ad174dd96d3069b0c11da6683afd935.svg";